<template>
  <div class="lp-step bg-people justify-content-start">
    <div class="step-5">
      <h1
        class="fs-32"
        style="width: 200px;"
      >
        {{ $t('Welcome to Boho!') }}
      </h1>
      <p>
        {{ $t('lps.Find a live video chat and voice chat partner in any mood!') }}
      </p>
      <b-button
        class="mt-2"
        type="submit"
        variant="primary"
        style="background-color: #AC33F4 !important; color: #fff !important; padding: 16px; border-radius: 16px;"
        block
        @click="$emit('nextStep')"
      >
        {{ $t('lps.Let’s do it!') }}
      </b-button>
    </div>
  </div>
</template>

<script>
import { BButton } from 'bootstrap-vue'

export default {
  name: 'Lp3Step5',
  components: {
    BButton,
  },
  props: {
    loading: {
      type: Boolean,
      required: true,
    },
    step: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {}
  },
  methods: {
  },
}
</script>

<style scoped lang="scss">
.step-5 {
  margin-top: 140px;
  padding: calc(40px) 20px;
  background: linear-gradient(180deg, rgba(255,255,255,0) 0%, rgba(255,255,255,1) calc(80% - 140px));
  height: calc(100% - 140px);
  display: flex;
  justify-content: end;
  flex-direction: column;
}
</style>
